import React, { MouseEvent, ReactNode, useCallback } from 'react'
import { useDrop } from 'react-dnd'

import { Title } from 'components/shared'
import { DraggableTask } from 'components/Admin'
import { Counter, TaskCol } from './DroppableAreaCol.style'

import { ITask, ITaskType } from 'store/taskManager/model'
import { useSelector } from 'react-redux'
import { TaskSkeleton } from '../../taskManager'

interface IDroppableAreaCol {
  colStatus: ITaskType
  onDrop: (status: ITaskType, item: ITask) => void
  taskList?: ITask[]
  // Это количество приходит из API
  totalCount?: number
  emptyState?: ReactNode
  title: string
  urgent?: boolean
  managers?: boolean
  onActivateTask: (id: number, e: MouseEvent<any>) => void
}

const DroppableAreaCol = (props: IDroppableAreaCol) => {
  const { colStatus, onDrop, taskList, totalCount, title, urgent, managers, onActivateTask, emptyState } = props
  const { tasks } = useSelector(({ taskManager }) => taskManager)

  const appendItem = useCallback(
    item => {
      onDrop(colStatus, item)
    },
    [onDrop]
  )

  const [collectedProps, drop] = useDrop({
    accept: 'card',
    drop: appendItem,
    collect: monitor => {
      return {
        didDrop: monitor.didDrop(),
        getDropResult: monitor.getDropResult(),
        hovered: monitor.isOver(),
      }
    },
  })

  // Тут скорее компромисс, который непонятно как иначе разрулить
  // Читай условие бага https://centrateam.atlassian.net/browse/CA-2617
  //
  // Суть в том, что каунтеры переведены на работу через API в задаче https://centrateam.atlassian.net/browse/CA-2585
  // Это позволяет выводить реальное количество тасков в колонке в БД, а не только то, которое видно.
  // Но при этом всем при перетаскивании задачи АМ-ом из колонки в колонку по ТЗ каунтеры начинают работать
  // через изменения в памяти браузера смотри `moveTaskSaga` в `src/store/taskManager/saga.tsx`.
  // Все это усложняется тем, что есть вариант, когда задача перетаскивается в колонку например "Выполнено", при том,
  // что на списке выбран фильтр задач "В работе". Т.е. сражу не становиться невозможным нормально перезапросить
  // данные с бека, так как там вернется ноль, а мы вроде как только что туда карточку таска перетащили и должно быть 1
  // в каунтере. При этом при клике на таск или в фоне может вызваться метод `getTaskListByActiveTaskSaga`, который
  // также обнулит каунтер.
  const totalCountForCounter = Number(taskList?.length) > Number(totalCount) ? taskList?.length : totalCount

  return (
    <TaskCol item xs ref={drop} $hovered={collectedProps.hovered}>
      <Title level={4} style={{ marginBottom: 16 }}>
        {title} <Counter>{totalCountForCounter}</Counter>
      </Title>

      {tasks[colStatus].loading ? (
        <>
          {Array.from(Array(5).keys()).map(key => (
            <TaskSkeleton key={key} />
          ))}
        </>
      ) : (
        <>
          {!!taskList?.length &&
            taskList.map(task => (
              <DraggableTask
                key={task.id}
                task={{
                  ...task,
                  taskType: colStatus,
                  urgent,
                  managers,
                }}
                adminView
                onActivate={onActivateTask}
              />
            ))}
          {!taskList?.length && emptyState && emptyState}
        </>
      )}
    </TaskCol>
  )
}

export default DroppableAreaCol
